import { Box, Typography } from '@mui/material';
import { IFichaEspectaculo } from 'utils/models/types';
import { theme } from 'theme/theme';
import { IPropValor } from 'utils/models/interfaces';

const InformacionEspectaculo = ({ esp }: { esp: IFichaEspectaculo }) => {
  const datosEspectaculo: IPropValor[] = [
    {
      propiedad: 'Duración',
      valor: `${esp.Funciones.length > 0 ? esp.Funciones[0].Duracion + ' minutos' : ''}`,
    },
    {
      propiedad: 'Elenco',
      valor: esp.Elenco,
    },
    {
      propiedad: 'Asistente de Dirección',
      valor: esp.AsistenteDireccion,
    },
    {
      propiedad: 'Vestuarista',
      valor: esp.Vestuarista,
    },
    {
      propiedad: 'Iluminación',
      valor: esp.Iluminador,
    },
    {
      propiedad: 'Sonidista',
      valor: esp.Sonidista,
    },
    {
      propiedad: 'Música',
      valor: esp.Musica,
    },
    {
      propiedad: 'Género',
      valor: esp.GeneroId,
    },
    {
      propiedad: 'Diseno Gráfico',
      valor: esp.DisenoGrafico,
    },
    {
      propiedad: 'Fotografía',
      valor: esp.Fotografia,
    },
    {
      propiedad: 'Escenografía',
      valor: esp.Escenografia,
    },
    {
      propiedad: 'Traducción',
      valor: esp.Traduccion,
    },
  ];

  return (
    <Box
      flex="1"
      maxHeight="500px"
      boxSizing="border-box"
      sx={{
        overflowY: 'auto',
        border: `1px solid ${theme.palette.secondary.main}`,
        backgroundColor: theme.palette.secondary.main,
        p: { xs: 2, md: 4 },
        borderRadius: 4,
      }}
    >
      <Box sx={{ backgroundColor: theme.palette.primary.main, color: 'white' }} p={3} borderRadius={4}>
        <Typography variant="body1">
          <b>{esp.Nombre}</b>
        </Typography>
        <Typography variant="body1">
          <b>Autor:</b> {esp.Autor}
        </Typography>
        <Typography variant="body1">
          <b>Dirección:</b> {esp.Director}
        </Typography>
      </Box>
      <Typography variant="body1" sx={{ my: 2 }} color={theme.palette.primary.main} textAlign="left">
        <i>{esp.Descripcion}</i>
      </Typography>
      {datosEspectaculo.map(
        ({ propiedad, valor }) =>
          valor && (
            <Box display="flex" gap={3} justifyContent="space-between" key={`${propiedad}${valor}`}>
              <Typography variant="body1" color={theme.palette.primary.main}>
                <b>{propiedad}</b>
              </Typography>
              <Typography variant="body1" textAlign="right" color="white">
                {valor}
              </Typography>
            </Box>
          )
      )}
    </Box>
  );
};

export default InformacionEspectaculo;
